import Resource from '../../resource/Resource';

// This is potentially a duplication of the 'Groups' store, but since they are never both loaded on the same page,
// we'll leave this here for now. In future, we may add group 'assessment' specific features here so that it is
// separate from the student 'group' management stuff

import {
  COHORT_GROUP_RETRIEVE_MANY,
  CREATE_COHORT_GROUP,
  DELETE_COHORT_GROUP,
  UPDATE_COHORT_GROUP,
  UPDATE_COHORT_GROUP_ADMIN_ACCESS,
  FETCH_COHORT_GROUP_USERS_START,
  FETCH_COHORT_GROUP_USERS_SUCCESS,
} from './actions';

export const GROUP_RESOURCE = 'group';

export function setCohortGroups(groups) {
  return (dispatch) => {
    dispatch({
      type: COHORT_GROUP_RETRIEVE_MANY,
      groups,
    });
  };
}

export function createCohortGroup(group, resolve, reject) {
  return (dispatch) => {
    Resource.create('group', group.toJS(), ['resource'])
      .then((response) => {
        dispatch({
          type: CREATE_COHORT_GROUP,
          group: response[0],
        });
        resolve();
      })
      .fail((result, response) => {
        reject({
          title: 'Error creating group',
          message: response.reason,
        });
      });
  };
}

export function deleteCohortGroup(group, resolve, reject) {
  return (dispatch) => {
    Resource.delete('group', group.get('id'))
      .then(() => {
        dispatch({
          type: DELETE_COHORT_GROUP,
          group,
        });
        resolve();
      })
      .fail((result, response) => {
        reject({
          title: 'Error deleting group',
          message: response.reason,
        });
      });
  };
}

/**
 * Updates group data locally.
 */
export function updateGroup(id, changes) {
  return (dispatch) => {
    dispatch({
      type: UPDATE_COHORT_GROUP,
      id,
      changes,
    });
  };
}

/**
 * Add a user to a group.
 *
 * callback(success, errorMessage, data)
 */
export const addUserToGroup = (group, userId, callback) => {
  return (dispatch) => {
    Resource.update(GROUP_RESOURCE, group.get('id'), 'addMember', { userId })
      .done((result) => {
        if (!result.success) {
          callback(false, result.error);
          return;
        }

        dispatch(updateGroup(group.get('id'), result.group));

        callback(true, null, result.group);
      })
      .fail((errorMessage) => {
        callback(false, errorMessage);
      });
  };
};

/**
 * Remove a user from a group.
 *
 * callback(success, errorMessage, data)
 */
export const removeUserFromGroup = (
  group,
  userId,
  callback,
  isPendingMember = false
) => {
  return (dispatch) => {
    Resource.update(GROUP_RESOURCE, group.get('id'), 'removeMember', {
      userId,
      isPendingMember,
    })
      .done((result) => {
        if (!result.success) {
          callback(false, result.error);
          return;
        }

        dispatch(updateGroup(group.get('id'), result.group));
        callback(true, null, result.group);
      })
      .fail((errorMessage) => {
        callback(false, errorMessage);
      });
  };
};

/**
 * Set user admin access.
 *
 * callback(success, errorMessage, data)
 */
export const setMemberAdminAccess = (
  group,
  userId,
  isAdmin,
  callback,
  isPendingMember = false
) => {
  return (dispatch) => {
    // Pre-emptively set the user's access locally
    dispatch({
      type: UPDATE_COHORT_GROUP_ADMIN_ACCESS,
      id: group.get('id'),
      userId,
      isAdmin,
    });

    Resource.update(GROUP_RESOURCE, group.get('id'), 'setMemberAdminAccess', {
      userId,
      isAdmin,
      isPendingMember,
    })
      .done((result) => {
        if (!result.success) {
          dispatch({
            type: UPDATE_COHORT_GROUP_ADMIN_ACCESS,
            id: group.get('id'),
            userId,
            isAdmin: !isAdmin, // reverse it,
          });
          callback(false, result.error);
          return;
        }

        dispatch(updateGroup(group.get('id'), result.group));
        callback(true, null, result.group);
      })
      .fail((errorMessage) => {
        dispatch({
          type: UPDATE_COHORT_GROUP_ADMIN_ACCESS,
          path: group.get('id'),
          userId,
          isAdmin: !isAdmin, // reverse it
        });

        callback(false, errorMessage);
      });
  };
};

export const fetchUsers = (group, userIds) => {
  return (dispatch) => {
    dispatch({
      type: FETCH_COHORT_GROUP_USERS_START,
      groupId: group.get('id'),
    });
    return Resource.read(GROUP_RESOURCE, group.get('id'), 'getUsers', {
      userIds: userIds.toJS(),
    }).done((result) => {
      dispatch({
        type: FETCH_COHORT_GROUP_USERS_SUCCESS,
        users: result.users,
      });
    });
  };
};
